var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tree-menu"},[_vm._l((_vm.menu),function(item,index){return [_c('re-sub-menu',{staticClass:"border-bottom",attrs:{"data":item}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }